/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IContactDetails } from 'app/shared/model/contact-details.model';
import { IUser } from 'app/shared/model/user.model';

export interface IHospital {
  id?: string;
  name?: string;
  createdDtm?: number;
  createdBy?: string;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  active?: boolean;
  cursor?: number;
  email?: string;
  registrationCode?: string | null;
  registrationAuth?: string | null;
  registrationState?: string | null;
  taxCode?: string | null;
  billPrefix?: string | null;
  panNumber?: string | null;
  tanNumber?: string | null;
  ownPanels?: boolean;
  contactCode?: IContactDetails;
  user?: IUser;
}

export const defaultValue: Readonly<IHospital> = {
  active: false,
  ownPanels: false,
};
